import TripMatchingContainer from './trip-matching-container';

export default TripMatchingContainer;
